import request from '@/utils/request';

// 获取课程包信息
export const getPaymentInfo = orderCode => {
  return request({
    method: 'GET',
    url: `/order/ext/paymentAsync/course/${orderCode}`
  })
}

// 第三方支付
export const goPyment = data => {
  return request({
    method: 'POST',
    url: `/order/ext/paymentAsync/payment`,
    data
  })
}

// 查询支付异常轮循次数
export function getPaymentCount(data) {
  return request({
    url: '/order/ext/paymentAsync/number',
    method: 'post',
    data
  })
}

// 生成支付记录
export const creatPaymentApi = data => {
  return request({
    method: 'POST',
    url: `/order/ext/paymentAsync/creatPayment`,
    data
  })
}

// 选择支付方式
// export const checkPay = (type, orderCode, year, schoolId) => {
//   return request({
//     method: 'GET',
//     url: type == 1 ? `/order/ext/paymentAsync/checkPay/${type}/${orderCode}` : `/order/ext/paymentAsync/checkPay/${type}/${orderCode}/${year}/${schoolId}`
//   })
// }

export const checkPay = (data) => {
  return request({
    method: 'PUT',
    url: '/order/ext/paymentAsync/checkPay',
    data
  })
}

// 支付结果
export const paymentResult = orderCode => {
  return request({
    method: 'GET',
    url: `/order/ext/paymentAsync/result/${orderCode}`
  })
}

// 获取学员待完善信息
export const getStudyInfo = orderCode => {
  return request({
    method: 'GET',
    url: `/order/ext/paymentAsync/studentInfo/${orderCode}`
  })
}

// 完善学院信息
export const saveStudyInfo = (code, data) => {
  return request({
    method: 'PUT',
    url: `/order/ext/paymentAsync/studentInfo/${code}`,
    data
  })
}

// 获取订单电子收据 165一期 
export const getReceiptNum = code => {
  return request({
    method: 'GET',
    url: `/order/ext/paymentAsync/receiptNumber/${code}`,
  })
}

// 获取字段详情
export function fieldConfigDetailApi(data) {
  return request({
    url: `/system/ext/fieldConfig/detail`,
    method: 'post',
    data: data
  })
}

// 获取所属分校对应的事业部
export const getShellBranchIdApi = id => {
  return request({
    method: 'GET',
    url: `/order/ext/order/shell/${id}`,
  })
}

// 获取完善信息
export const getInformationaApi = id => {
  return request({
    method: 'GET',
    url: `/order/ext/order/completed/information/${id}`,
  })
}

// 获取电子收据信息（住宿）
export const getStayInformationaApi = id => {
  return request({
    method: 'GET',
    url: `/order/ext/dormitory/electronicReceipt/${id}`,
  })
}

// 编辑完善信息
export const patchInformationaApi = data => {
  return request({
    method: 'PATCH',
    url: `/order/ext/order/perfect/information`,
    data
  })
}

// 课程包收款-保存学员信息
export const patchStudentInfoApi = data => {
  return request({
    method: 'PATCH',
    url: `/order/ext/student/supplement/information`,
    data
  })
}

